module.exports = __webpack_public_path__ + "static/phone6-176862cbf180680b59d2d7317dd7cb5f.png";